export enum CSVVarHeaders {
  Name = 'Name',
  Value = 'Value',
  'Currency (yes/no)' = 'Currency (yes/no)',
}

export interface CsvVariable {
  name: string;
  value: number | undefined;
  currency: boolean;
}

export interface CsvImportPreview {
  variables: CsvVariable[];
  fileName: string;
  summary: {
    total: number;
    toUpdate: number;
    toCreate: number;
    toOverride: number;
  };
  /** Assessment-scope groupings for user selection */
  groups?: CsvImportGroups;
  /** Workspace-scope groupings for user selection */
  workspaceGroups?: CsvWorkspaceGroups;
}

export type MatchType = 'update' | 'create' | 'override';

/** Import action options for each group */
export type ImportAction = 'include' | 'exclude';

/** Grouped variables for assessment scope imports */
export interface CsvImportGroups {
  /** Variables that exist as custom assessment variables (not workspace) */
  customAssessmentVars: {
    variables: CsvVariable[];
    action: ImportAction;
  };
  /** Variables that match workspace variables but aren't overridden yet */
  workspaceVars: {
    variables: CsvVariable[];
    action: ImportAction;
  };
  /** Variables that are already overridden at assessment level */
  overriddenVars: {
    variables: CsvVariable[];
    action: ImportAction;
  };
  /** New variables that don't exist anywhere */
  newVars: {
    variables: CsvVariable[];
    action: ImportAction;
  };
}

/** Grouped variables for workspace scope imports */
export interface CsvWorkspaceGroups {
  /** Existing workspace variables to update */
  existingVars: {
    variables: CsvVariable[];
    action: ImportAction;
  };
  /** New variables to create (auto-included, no dialog) */
  newVars: {
    variables: CsvVariable[];
    action: ImportAction;
  };
}
